import React from 'react';
import { Bookmark, CheckCheck } from 'lucide-react';
import styles from './StudentWelcome.module.css';

function InfoCards() {
  return (
    <div className={styles.infoCardsContainer}>
      <div className={styles.infoCard}>
        <h3 className={styles.infoCardTitle}>
          <Bookmark className={styles.infoCardIcon} />
          Save 3 Positions
        </h3>
        <p className={styles.infoCardDescription}>
          Browse available research opportunities and save the ones that align with your interests and career goals.
        </p>
        <ul className={styles.infoCardList}>
          <li>• Explore research opportunities by field</li>
          <li>• Filter by location and requirements</li>
          <li>• Compare position details and benefits</li>
        </ul>
      </div>
      
      <div className={styles.infoCard}>
        <h3 className={styles.infoCardTitle}>
          <CheckCheck className={styles.infoCardIcon} />
          AI Matching
        </h3>
        <p className={styles.infoCardDescription}>
          Get personalized recommendations based on your profile, skills, and research interests using our AI system.
        </p>
        <ul className={styles.infoCardList}>
          <li>• Resume analysis and skill matching</li>
          <li>• Research interest compatibility</li>
          <li>• Academic background alignment</li>
        </ul>
      </div>
    </div>
  );
}

export default InfoCards;